import React, { useState, useEffect } from 'react';
import MultipleSelection from '../MultipleSelection/MultipleSelection';
import SingleSelection from '../SingleSelection/SingleSelection';

const ExploreQuestions = props => {
  // console.log(props.data);

  const { data } = props;

  const [ currentQuestion, setCurrentQuestion ] = useState(0);
  const [ currentStep, setCurrentStep ] = useState(0);
  const [ pointsPerQuestion, setPointsPerQuestion ] = useState(0);
  const [ visibleTabs, setVisibleTabs ] = useState(0);

  const checkVisibleTabs = () => {
    let visible = 0;
    data.tabs.map( (tab) => {
      if(tab.visible) {
        visible += 1;
      }
    });
    // console.log(visible);
    setVisibleTabs(visible);
  };

  const handleScroll = (direction = 'right') => {
    const element = document.getElementById("nav-tabs-container");
    const width = element.offsetWidth;
    const scrollWidth = element.scrollWidth;
    const currentScroll = element.scrollLeft;

    let scrollAmount = 0;
    if(direction === 'left') {
      scrollAmount = currentScroll - ( ( width / data.options.visibleTabs ) * data.options.scrollBy );
    } else {
      scrollAmount = currentScroll + ( ( width / data.options.visibleTabs ) * data.options.scrollBy );
    }

    element.scrollTo({
      left: scrollAmount,
      behavior: 'smooth'
    });

  };

  const pointsByQuestion = () => {
    let ppq = 0;
    let questionCount = 0;
    data.tabs.map((tab) => {
      if(tab.questions.length > 0) {
        tab.questions.map((question) => {
          questionCount += 1;
        })
      }
    });
    ppq = 100 / questionCount;
    setPointsPerQuestion(ppq);
    // console.log(questionCount, ppq);
  };

  const nextQuestion = (err) => {
    // debugger;
    // let errors = 0;
    // let questions = data.tabs[props.currentTab].questions;
    if(err) {
    //   questions[currentQuestion].completed = false;
    } else {
    //   questions[currentQuestion].completed = true;
      props.changeScore(pointsPerQuestion);
    }

    // filter for imcomplete questions
    // questions.forEach( (step) => {
    //   if(!step.completed) {
    //     errors += 1;
    //   }
    // });
    
    // console.log(props.score);
    const questionsLength = data.tabs[currentStep].questions.length;
    if(currentQuestion + 1 < questionsLength) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      let tabsLength = data.tabs.length;
      if(currentStep + 1 < tabsLength) {
        setCurrentQuestion(0);
        setCurrentStep(currentStep + 1);
        if(props.currentTab !== currentStep){
          //Cannot update a component (`ExploreTheConcepts`) while rendering a different component (`ExploreTabs`).
          //props.changeTab(currentStep + 1);
        }
        // if(visibleTabs >= data.options.visibleTabs) {
        //   setTimeout(() => {
        //     handleScroll('right');
        //   }, 1000);
        // }
      }
      // console.log('you complete the quiz');
      // let finalScore = ( questionsLength - errors) * (100 / questionsLength);
      // console.log(`your score is ${parseInt(finalScore)}`);
      // setScore(parseInt(finalScore));
    }
  }

  useEffect(() => {
    pointsByQuestion();
  }, []);

  useEffect(() => {
    checkVisibleTabs();
  }, [data]);

  return (
    <div className="questions">
      {
        props.data.tabs[currentStep].questions.map( (question, questionIndex) => {
          if(currentQuestion===questionIndex) {
            if(question.type==='single-selection') {
              return <SingleSelection data={question} onComplete={nextQuestion} options={data.options} key={`question-${questionIndex}`} />;
            }
            if(question.type==='multiple-selection') {
              return <MultipleSelection data={question} onComplete={nextQuestion} options={data.options} key={`question-${questionIndex}`} />;
            }
          } 
          
        })
      }
    </div>
  );
};

export default ExploreQuestions;